import {useMemo} from "react";
import {missingAnswers} from "../util/missingAnswers";

// The same check the hook does, usable outside a render — the fetched answers have to be judged
// complete before the form decides whether to lock itself.
export function answersComplete(answers) {
	if (!answers) {
		return false;
	}
	return missingAnswers(answers).missing.length === 0;
}

export default function useCanContinue(answers){
	return useMemo(() => answersComplete(answers), [answers]);
}
